import React, { useState, useContext, useEffect } from 'react';
import {IProps, IState} from './types';
import * as S from './styles';
import { Context } from "routes/private/Editor/Context";
import Tooltip from '@components/Tooltip';
import ClickOutside from '@components/ClickOutside';
import { BorderIcon } from 'assets/icons/borderIcon';
import Slider from 'rc-slider/lib/Slider';
import ColorPicker from 'routes/private/Editor/Editor/Pickers/ColorPicker';
import { isCloseToWhite } from '@utils/colors';
import { getTaggedVisibleElementsId } from '@utils/selectDescribe';
import { getDifferentValues } from '@utils/multiEditing';
import { findCommonAttributeValue, findDifferentAttributeValues } from '@utils/editor';
import { borderDashResolver } from '@routes/private/Editor/resolvers';
import { useSelector } from 'react-redux';
import selectors from '@state/selectors';

const BorderComandOption:React.FC<IProps> = (props) => {
  let { editorStatus, data,selectDescribe, onCommandChange} = useContext(Context);
  const dsConfig = useSelector(selectors.dsConfig.getDSConfig);  
  const [bgColors, setBgColors]= useState<string[]>([]);
  const [isSelected, setIsSelected]= useState(false);
  const [borderWidth, setBorderWidth]= useState<number|undefined>(0);
  const [dashValue, setDashValue]= useState<number|undefined>(0);  
  const [spaceValue, setSpaceValue]= useState<number|undefined>(0);
  const [cornerRadiusValue, setCornerRadiusValue] = useState<number | undefined>(0);

    
  const minBorder = dsConfig.editorConfig.borderWidth.min;
  const maxBorder =  dsConfig.editorConfig.borderWidth.max;
  const minDash = dsConfig.editorConfig.borderDash.min;
  const maxDash = dsConfig.editorConfig.borderDash.max;
  const minSpace= dsConfig.editorConfig.borderWhiteSpace.min;
  const maxSpace= dsConfig.editorConfig.borderWhiteSpace.max;
  const minCorner = 0;
  const maxCorner = 100;

  const [values, setValues]= useState<string[]>([]);
  const [showPicker, setShowPicker]= useState(false);
  
  useEffect(() => {
    const bgcolors = findDifferentAttributeValues(editorStatus.selectedElementsId, data, "borderColor","Shape");    
    setBgColors(bgcolors);
  }, [editorStatus.selectedElementsId.length, editorStatus.selectedElementsId[0], data]);
  

  useEffect(() => {    
    const borderwidth = findCommonAttributeValue(editorStatus.selectedElementsId, data, "borderWidth");
    const borderdash = findCommonAttributeValue(editorStatus.selectedElementsId, data, "borderDash");
    const borderspace = findCommonAttributeValue(editorStatus.selectedElementsId, data, "borderWhiteSpace");       
    const cornerRadius = findCommonAttributeValue(editorStatus.selectedElementsId, data, "cornerRadius");
    setBorderWidth(borderwidth!==undefined?parseFloat(borderwidth):0)        
    setDashValue(borderdash!==undefined?parseFloat(borderdash):0)        
    setSpaceValue(borderspace!==undefined?parseFloat(borderspace):0)        
    setCornerRadiusValue(cornerRadius !== undefined ? parseFloat(cornerRadius) : 0);
    }, [editorStatus.selectedElementsId.length, editorStatus.selectedElementsId[0], data]);
  

  const onChangeValue = (newValue: string) => {
    setValues([newValue]);
  }


  const SetBorderWidth = (value: number|undefined, notSave?:boolean) => {  
    setBorderWidth(value);
    onCommandChange("borderWidth", value, undefined, undefined, notSave);          
  }

  const SetBorderDash = (value: number|undefined, notSave?:boolean) => {  
    setDashValue(value);
    onCommandChange("borderDash", value, undefined, undefined, notSave);          
  }

  const SetBorderSpace = (value: number|undefined, notSave?:boolean) => {  
    setSpaceValue(value);
    onCommandChange("borderSpace", value, undefined, undefined, notSave);          
  }

  const SetCornerRadius = (value: number|undefined, notSave?:boolean) => {  
    setCornerRadiusValue(value);
    onCommandChange("cornerRadius", value, undefined, undefined, notSave);          
  }

  const handleInputWidthSlider = (e: any) => {
    const inputText = e.target.value;
    if(inputText==="" || inputText==="-" || (!isNaN(inputText) && parseFloat(inputText)<minBorder && parseFloat(inputText)>=Math.trunc(minBorder))) {
      SetBorderWidth(undefined);    
    }

    if(!isNaN(inputText) && parseFloat(inputText)>=minBorder && parseFloat(inputText)<=maxBorder) {
      SetBorderWidth(parseFloat(inputText));      
    }
  }

  const handleInputDashSlider = (e: any) => {
    const inputText = e.target.value;
    if(inputText==="" || inputText==="-" || (!isNaN(inputText) && parseFloat(inputText)<minDash && parseFloat(inputText)>=Math.trunc(minDash))) {
      SetBorderDash(undefined);    
    }

    if(!isNaN(inputText) && parseFloat(inputText)>=minDash && parseFloat(inputText)<=maxDash) {
      SetBorderDash(parseFloat(inputText));      
    }
  }

  const handleInputSpaceSlider = (e: any) => {
    const inputText = e.target.value;
    if(inputText==="" || inputText==="-" || (!isNaN(inputText) && parseFloat(inputText)<minSpace && parseFloat(inputText)>=Math.trunc(minSpace))) {
      SetBorderSpace(undefined);    
    }

    if(!isNaN(inputText) && parseFloat(inputText)>=minSpace && parseFloat(inputText)<=maxSpace) {
      SetBorderSpace(parseFloat(inputText));      
    }
  }

  const handleInputCornerSlider = (e: any) => {
    const inputText = e.target.value;
    if(inputText==="" || inputText==="-" || (!isNaN(inputText) && parseFloat(inputText)<minCorner && parseFloat(inputText)>=Math.trunc(minCorner))) {
      SetCornerRadius(undefined);    
    }

    if(!isNaN(inputText) && parseFloat(inputText)>=minCorner && parseFloat(inputText)<=maxCorner) {
      SetCornerRadius(parseFloat(inputText));      
    }
  }

  const handleFocus = () => {
    setShowPicker(!showPicker);
    //context.onMultiEditingFocus([props.selectDescribeFieldId]);
    const differentValues = getDifferentValues("borderColor","Shape","",data,selectDescribe?.taggedFields);
    setValues(differentValues);
  }

  const isOneColorCloseToWhite = () => {
    for (let i=0;i<values.length;i++) {
      if(isCloseToWhite(values[i])) {
        return true;
      }
    }
    return false;
  } 
  
  const sliderStyles = {
    railStyle: S.SliderRail,
    handleStyle: S.SliderHandle,
    trackStyle: S.SliderTrack,
    dotStyle: S.SliderDot,
  }
  
  return (
    <S.Root>
    <ClickOutside onClickOutside={()=> setIsSelected(false)}>
      <Tooltip tip={"Border"} boxStyle={isSelected ? {display:'none'}:undefined}>
        <S.ButtonContainer fromImage={props.fromImage} onClick={()=> setIsSelected(!isSelected)} isSelected={isSelected}>
          <BorderIcon/>
        </S.ButtonContainer>
      </Tooltip>
      <S.OptionsList style={{ display: isSelected ? "flex" : "none" }}>
        {
          !props.fromImage &&
          <>
            <S.optionContainer>
              <S.Label>
                Border Width
              </S.Label>
              <S.SliderContainer>
                <Slider
                  min={minBorder}
                  max={maxBorder}
                  step={1}
                  startPoint={0}
                  value={borderWidth}
                  onChange={(e) => { SetBorderWidth(e, true); }}
                  onAfterChange={(e) => { SetBorderWidth(e); }}
                  {...sliderStyles}
                />
              </S.SliderContainer>
              <S.InputSlider
                value={borderWidth !== undefined ? borderWidth : ""}
                onChange={handleInputWidthSlider}
              ></S.InputSlider>
            </S.optionContainer>
            <S.optionContainer>
              <S.Label>
                Dashes
              </S.Label>
              <S.SliderContainer>
                <Slider
                  min={minDash}
                  max={maxDash}
                  step={1}
                  startPoint={0}
                  value={dashValue}
                  onChange={(e) => { SetBorderDash(e, true); }}
                  onAfterChange={(e) => { SetBorderDash(e); }}
                  {...sliderStyles}
                />
              </S.SliderContainer>
              <S.InputSlider
                value={dashValue !== undefined ? dashValue : ""}
                onChange={handleInputDashSlider}
              ></S.InputSlider>
            </S.optionContainer>
            <S.optionContainer>
              <S.Label>
                White Space
              </S.Label>
              <S.SliderContainer>
                <Slider
                  min={minSpace}
                  max={maxSpace}
                  step={1}
                  startPoint={0}
                  value={spaceValue}
                  onChange={(e) => { SetBorderSpace(e, true); }}
                  onAfterChange={(e) => { SetBorderSpace(e); }}
                  {...sliderStyles}
                />
              </S.SliderContainer>
              <S.InputSlider
                value={spaceValue !== undefined ? spaceValue : ""}
                onChange={handleInputSpaceSlider}
              ></S.InputSlider>
            </S.optionContainer>
          </>
        }
        <S.optionContainer>
          <S.Label>
            Rounded Corners
          </S.Label>
          <S.SliderContainer>
            <Slider
              min={minCorner}
              max={maxCorner}
              step={1}
              startPoint={0}
              value={cornerRadiusValue}
              onChange={(e) => { SetCornerRadius(e, true); }}
              onAfterChange={(e) => { SetCornerRadius(e); }}
              {...sliderStyles}
            />
          </S.SliderContainer>
          <S.InputSlider
            value={cornerRadiusValue !== undefined ? cornerRadiusValue : ""}
            onChange={handleInputCornerSlider}
          ></S.InputSlider>
        </S.optionContainer>
        {
          !props.fromImage &&
          <S.optionContainer>
            <S.Label>
              Border Color
            </S.Label>
            <S.ColorContainer>
              <S.ColorRect hasOneColorCloseToWhite={isOneColorCloseToWhite()} onClick={() => handleFocus()}>
                {
                  bgColors.length === 0 &&
                  <>
                    <S.ColorSection hasOneColorCloseToWhite={false} backgroundColor={"#000000"} first={true} last={true} />
                  </>
                }
                {
                  bgColors.length > 0 &&
                  <>
                    {
                      bgColors.map((value, index) => {
                        return (
                          <S.ColorSection hasOneColorCloseToWhite={isOneColorCloseToWhite()} backgroundColor={value} first={index === 0} last={index === bgColors.length - 1} />
                        )
                      })
                    }
                  </>
                }
              </S.ColorRect>
            </S.ColorContainer>
          </S.optionContainer>
        }
        {
          showPicker &&
          <S.PickerContainer>
            <S.ColorSpacer>
              <ColorPicker drawBox={false} onChangeValue={(newValue) => onChangeValue(newValue)} elementsIds={editorStatus.selectedElementsId} pickerProperties={{ elementType: "Shape", colorAttribute: "borderColor" }}>
              </ColorPicker>
            </S.ColorSpacer>
          </S.PickerContainer>
        }
      </S.OptionsList>
    </ClickOutside>
  </S.Root>
  );
}

export default BorderComandOption;